import Divider from 'antd/lib/divider';
import Space from 'antd/lib/space';
import Tag from 'antd/lib/tag';
import Tooltip from 'antd/lib/tooltip';
import { dayjs } from '@/extendedDayjs';
import * as React from 'react';
import { tagColorForTicketStatus } from '../../helpers';
import { DatetimeFormat } from '../../timeHelpers';
import { IntegrationType, TicketItem } from '../../types';
import { antGrey, tagStyle } from '../styles/globalStyles';
import Text from 'antd/lib/typography/Text';
import Link from 'antd/lib/typography/Link';

interface TicketStatusProps {
    ticket?: TicketItem;
    ignored: boolean;
}

const TicketStatus: React.FC<TicketStatusProps> = (props: TicketStatusProps) => {
    if (!props.ticket) {
        return (
            <Tooltip title="This code has not been associated to a ticket in your project management platform.">
                <Text type="secondary">No ticket found</Text>
            </Tooltip>
        );
    }

    const status = props.ticket.status;
    const bgColor = tagColorForTicketStatus(props.ticket.isTicketDone);

    const itemDate = props.ticket.updatedAt ?? props.ticket.createdAt;
    const formattedDate =
        itemDate ? dayjs(itemDate).format(DatetimeFormat.DayAbbreviatedMonthDateYearTimeAbbreviated) : null;

    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Tooltip title={formattedDate ? `Updated on ${formattedDate}` : null}>
                <Tag color={bgColor} style={{ ...tagStyle, fontSize: 10 }}>
                    {status}
                </Tag>
            </Tooltip>
            <Space
                align="center"
                split={
                    <Divider
                        type="vertical"
                        style={{ backgroundColor: antGrey.grey5, marginLeft: 2, marginRight: 2, height: '75%' }}
                    />
                }
                style={{ alignItems: 'stretch', width: '100%' }}
                className="space-code-ticket-status"
            >
                <Link
                    href={props.ticket.url}
                    target="_blank"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={(e) => e.stopPropagation()} //stop drawer from opening
                    strong
                >
                    {props.ticket.identifier}
                </Link>
                {props.ticket?.project ?
                    props.ticket.project.displayableName !== '' ?
                        <Link
                            href={props.ticket.project.url}
                            target="_blank"
                            onClick={(e) => e.stopPropagation()} //stop drawer from opening
                            ellipsis
                        >
                            {props.ticket.project.displayableName}
                        </Link>
                    :   null
                :   <Text type="secondary" style={{ whiteSpace: 'nowrap' }}>
                        {`No ${IntegrationType.Linear ? 'Team' : 'Project'}`}
                    </Text>
                }
            </Space>
        </Space>
    );
};

export default TicketStatus;
